<app-dialog-header
  [title]="data.title"
  (close)="dialogRef.close()"
/>

<div
  style="
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  "
>
  <div>
    {{data.description}}
  </div>

  <div>
    <kpi4me-select-element
      [formControlElement]="languageFormControl"
      [options]="data.languages"
      label="Sprache"
      [multiple]="false"
      [deleteEnabled]="false"
      [createNewEnabled]="false"
      [editEnabled]="false"
    />
  </div>
</div>
<mat-dialog-actions style="margin-top: 20px">
  <div style="display: flex">
    <app-confirm-icon-button
      (click)="onConfirm()"
      [matTooltip]="data.confirmText"
    />

    <app-cancel-icon-button
      style="margin-left: 1rem"
      (click)="onCancel()"
      [matTooltip]="data.cancelText"
    />
  </div>
</mat-dialog-actions>
